/*
  BKM: egna texter i Recharge-widgeten (22 okt 2026)
  Konfig sätts i layout/theme.liquid som window.BKM_WIDGET_COPY, nyckel = planens intervall
  (Recharge-option "Order Frequency and Unit", t.ex. "3-month", "1-month"):
    { "3-month": { "title": "...", "sub": "..." }, "1-month": { ... } }
  title = radens rubrik (ersätter selling plan-namnet i widgeten, badge "Save x%" behålls)
  sub   = första raden i förmånslistan ("{amount}-months supply shipped every ...")
  null/utelämnad = behåll Recharges text. sub "" = dölj den raden.
  Test utan att ändra konfig: ?bkm_copy=A (kandidat A nedan). ?bkm_debug=1 loggar.
  Hoppar över handles i window.BKM_WIDGET_COPY_SKIP (standard: harmonized) och produkter utan refill-variant.
*/
(function () {
  'use strict';
  if (window.__bkmWidgetCopy) return;
  window.__bkmWidgetCopy = true;
  var DEBUG = /bkm_debug=1/.test(location.search);
  function log() { if (DEBUG && window.console) console.log.apply(console, ['[BKM-COPY]'].concat([].slice.call(arguments))); }

  var CANDIDATES = {
    A: {
      '3-month': { title: '3-month supply', sub: 'Starts with 1 can + 2 refills, then 3 refills every 3 months' },
      '1-month': { title: null, sub: 'Starts with 1 can, then 1 refill every month' }
    }
  };
  var m = location.search.match(/bkm_copy=([A-Za-z0-9_-]+)/);
  var COPY = (m && CANDIDATES[m[1]]) || window.BKM_WIDGET_COPY || {};
  function has(k) { return COPY[k] && ((COPY[k].title != null) || (COPY[k].sub != null)); }
  if (!Object.keys(COPY).some(has)) { log('ingen konfig'); return; }

  function getProductJson() {
    var el = document.querySelector('script[data-product-json]') || document.querySelector('script[id^="ProductJson"]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  var product = getProductJson();
  if (!product) return;
  // Skydd: refill-texter bara på produkter som faktiskt har burk + refill.
  // Handles i window.BKM_WIDGET_COPY_SKIP (t.ex. "harmonized") eller produkter utan refill-variant behåller Recharges text.
  var SKIP = window.BKM_WIDGET_COPY_SKIP || ['harmonized'];
  var REFILL_RE = /(refill|bag|påfyllning|pafyllning|påse|pase|pouch)/i;
  var hasRefill = (product.variants || []).some(function (v) { return REFILL_RE.test(v.title || '') || /^2/.test(String(v.sku || '')); });
  if (SKIP.indexOf(product.handle) !== -1 || !hasRefill) { log('hoppar över', product.handle, 'hasRefill=', hasRefill); return; }
  var planKey = {};
  (product.selling_plan_groups || []).forEach(function (g) {
    (g.selling_plans || []).forEach(function (p) {
      if (p.recurring_deliveries === false) return;
      var key = null;
      (p.options || []).forEach(function (o) { var mm = String(o.value || '').match(/^(\d+)[- ]?(day|week|month|year)s?$/i); if (mm && !key) key = mm[1] + '-' + mm[2].toLowerCase(); });
      if (key) planKey[String(p.id)] = key;
    });
  });
  log('planKey', planKey);

  function deepQueryAll(root, sel, out) {
    out = out || [];
    if (!root) return out;
    try { root.querySelectorAll(sel).forEach(function (n) { out.push(n); }); } catch (e) {}
    try { root.querySelectorAll('*').forEach(function (n) { if (n.shadowRoot) deepQueryAll(n.shadowRoot, sel, out); }); } catch (e) {}
    return out;
  }
  function setText(tn, txt) {
    if (tn.__bkmOrig == null) tn.__bkmOrig = tn.textContent;
    if (tn.textContent.trim() === txt) return;
    // behåll omgivande whitespace
    tn.textContent = tn.textContent.replace(/^(\s*)[\s\S]*?(\s*)$/, function (_, a, b) { return a + txt + b; });
  }
  function firstTextNode(el) {
    for (var c = el.firstChild; c; c = c.nextSibling) if (c.nodeType === 3 && c.textContent.trim()) return c;
    return null;
  }
  function run() {
    document.querySelectorAll('recharge-subscription-widget').forEach(function (w) {
      deepQueryAll(w.shadowRoot || w, 'input[name="quantityUpsellOption"], input[type="radio"]').forEach(function (r) {
        var key = planKey[String(r.value)];
        var cfg = key && COPY[key];
        if (!cfg) return;
        var row = r.closest('.rc-quantity-upsell-option') || r.closest('label');
        if (!row) return;
        if (cfg.title != null) {
          var t = row.querySelector('.rc-quantity-upsell-option__title, .rc-purchase-option__plan-name');
          var tn = t && firstTextNode(t);
          if (tn) setText(tn, cfg.title);
        }
        if (cfg.sub != null) {
          var lis = deepQueryAll(row, 'rc-benefits li, .rc-benefits__list li');
          var li = lis[0];
          if (li) {
            if (cfg.sub === '') { li.style.display = 'none'; }
            else { li.style.display = ''; var ltn = firstTextNode(li); if (ltn) setText(ltn, cfg.sub); }
          }
        }
      });
    });
  }
  var observed = typeof WeakSet !== 'undefined' ? new WeakSet() : null;
  var queued = false;
  function schedule() { if (queued) return; queued = true; (window.requestAnimationFrame || setTimeout)(function () { queued = false; run(); observe(); }); }
  function observe() {
    if (!observed || typeof MutationObserver === 'undefined') return;
    document.querySelectorAll('recharge-subscription-widget').forEach(function (w) {
      var roots = [w.shadowRoot].concat(deepQueryAll(w.shadowRoot, '*').map(function (e) { return e.shadowRoot; }));
      roots.forEach(function (r) {
        if (!r || observed.has(r)) return;
        observed.add(r);
        new MutationObserver(schedule).observe(r, { childList: true, subtree: true, characterData: true });
      });
    });
  }
  function start() { run(); observe(); setInterval(function () { run(); observe(); }, 500); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
